/** Definição estática das colunas da Vuetable — mesma estrutura que existia em `data()`. */
export function createExpedicaoVuetableFields() {
  return [
    {
      name: "__checkbox",
      titleClass: "center aligned",
      dataClass: "center aligned",
    },
    {
      name: "numCarga",
      title: "N Carga",
    },
    {
      name: "__slot:dtExpedicao",
      title: "Dt.Expedição Carga",
    },
    {
      name: "__slot:unidade",
      title: "Unidade",
    },
    {
      name: "__slot:transportadora",
      title: "Transportadora",
    },
    {
      name: "__slot:meioTranspPri",
      title: "Meio de Transp.",
    },
    {
      name: "vlrTotalNfs",
      title: "Vlr. total NF",
      callback: "formatNumber",
    },
    {
      name: "pesoBruto",
      title: "Peso bruto",
      callback: "formatNumber",
    },
    {
      name: "pesoLiquido",
      title: "Peso líquido",
      callback: "formatNumber",
    },
    {
      name: "qtdVolume",
      title: "Qtde. Volumes",
      callback: "formatNumber",
    },
    {
      name: "qtdVolumes",
      title: "Qtde. volumes bip",
      callback: "formatNumber",
    },
    {
      name: "qtdDocs",
      title: "Qtde. documentos",
      callback: "formatNumber",
    },
    {
      name: "qtdNfs",
      title: "Qtde. Nfs",
      callback: "formatNumber",
    },
    {
      name: "obs",
      title: "Obs",
    },
    {
      name: "__slot:statusProcessoExpedicao",
      title: "Processo expedição",
    },
    {
      name: "__slot:status",
      title: "Status",
    },
    {
      name: "__slot:actions",
      title: "Ações",
      titleClass: "center aligned",
      dataClass: "center aligned",
    },
  ];
}
